export default "__VITE_ASSET__5708289b__"